import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';

@Component({
  selector: 'app-createfolderforForm',
  templateUrl: './createfolderforForm.component.html',
  styleUrls: ['./createfolderforForm.component.scss'] 
})

export class CreatefolderforFormComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;   
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;

  constructor(private dialog: MatDialog,   
    public dialogRef: MatDialogRef<CreatefolderforFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private formService: FormsService,private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }  
  
  ngOnInit(): void {  
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('formFolderName', this.formBuilder.control(''));   
  }     
    

  keypressed($event,value){
   if($event.keyCode=="13"){
     this.AddFolderName(value);
   }
  }
  
  AddFolderName(data) {
    this.formDialog.markAsPristine();
    this.spinner=true;
    this.data;
    //var formFolderID = Object.values(this.data)[0];
    var parentID = Object.values(this.data)[0];
    
    let ReqModel = {
      formFolderID: 0,//formFolderID,
      formFolderName:  data.formFolderName.trim(),
      parentID:parentID,
      organizationID: Number(this.organizationId),
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      UserId: this.currentUser.UID,
      officeID:this.myOfficeID      
   }
   this.formService.AddFormFolder(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.data == true && this.responseHolder.status == this.statusConst.statusSuccess) {
         this.formDialog.reset();
         this.dialogRef.close("Added");
         this.spinner=false;
         this.toastr.success('Folder Created successfully.', '', {
           timeOut: 3000,
         });     
       }
       if (this.responseHolder.data == false && this.responseHolder.status == 500) {
        this.spinner=false;
        this.toastr.warning('Folder Name Already Exist.', '', {
          timeOut: 3000,
        });
       }  
     }
   });
 }

 close() {   
  this.formDialog.reset();
  this.dialog.closeAll();
}
  
}
